import { jsx } from "react/jsx-runtime";
import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { S as SHADE_APP_NAMESPACES } from "../../shade-app-Dj6sDEso.js";
import { cn } from "../../lib/ds-utils.js";
import "moment-timezone";
import "validator/es/lib/isEmail";
const Popover = ({
  open: controlledOpen,
  defaultOpen,
  onOpenChange,
  children,
  ...rest
}) => {
  const isControlled = controlledOpen !== void 0;
  const [internalOpen, setInternalOpen] = React.useState(defaultOpen ?? false);
  const open = isControlled ? controlledOpen : internalOpen;
  const handleOpenChange = React.useCallback((next) => {
    if (!isControlled) {
      setInternalOpen(next);
    }
    onOpenChange?.(next);
  }, [isControlled, onOpenChange]);
  const handleOpenChangeRef = React.useRef(handleOpenChange);
  React.useEffect(() => {
    handleOpenChangeRef.current = handleOpenChange;
  }, [handleOpenChange]);
  React.useEffect(() => {
    if (!open) {
      return;
    }
    const handleEscape = (event) => {
      if (event.key !== "Escape") {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      handleOpenChangeRef.current(false);
    };
    document.addEventListener("keydown", handleEscape, { capture: true });
    return () => document.removeEventListener("keydown", handleEscape, { capture: true });
  }, [open]);
  return /* @__PURE__ */ jsx(
    PopoverPrimitive.Root,
    {
      ...rest,
      open,
      onOpenChange: handleOpenChange,
      children
    }
  );
};
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverClose = PopoverPrimitive.Close;
const PopoverContent = React.forwardRef(({ className, align = "center", sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsx("div", { className: SHADE_APP_NAMESPACES, children: /* @__PURE__ */ jsx(
  PopoverPrimitive.Content,
  {
    ref,
    align,
    className: cn(
      "z-50 rounded-md bg-popover p-5 text-popover-foreground shadow-md border outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-popover-content-transform-origin)",
      className
    ),
    sideOffset,
    ...props
  }
) }) }));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export {
  Popover,
  PopoverAnchor,
  PopoverClose,
  PopoverContent,
  PopoverTrigger
};
//# sourceMappingURL=popover.js.map
